import * as React from 'react';
import Modal from 'react-modal';

import DeviceSettingsItemTemplate from './DeviceSettingsItemTemplate';
// @ts-ignore
import LinkDeviceModal from 'user/components/LinkDeviceModal';
// @ts-ignore
import TextAppLinkDialog from 'user/components/TextAppLinkDialog';
import { ConfirmableDeviceType } from 'entities/Device';

export type Props = {
  deviceType: string;
  refetchDevices: () => void;
};

type State = {
  textAppLinkDialogIsOpen: boolean;
  linkDeviceModalIsOpen: boolean;
};

type DeviceTypeToConfirmableDeviceType = {
  sms: ConfirmableDeviceType;
  email: ConfirmableDeviceType;
};

export default class DeviceSettingsEmptyItem extends React.Component<Props, State> {
  state = {
    textAppLinkDialogIsOpen: false,
    linkDeviceModalIsOpen: false,
  };

  showTextAppLinkDialog = () => {
    this.setState({ textAppLinkDialogIsOpen: true });
  };

  hideTextAppLinkDialog = () => {
    this.setState({ textAppLinkDialogIsOpen: false });
  };

  showLinkDeviceModalDialog = () => {
    this.setState({ linkDeviceModalIsOpen: true });
  };

  hideLinkDeviceModalDialog = () => {
    this.setState({ linkDeviceModalIsOpen: false });
  };

  getAction = () => {
    const { deviceType } = this.props;

    switch (deviceType) {
      case 'apns':
        return {
          label: 'Get the app',
          action: this.showTextAppLinkDialog,
        };
      case 'sms':
        return {
          label: 'Add phone',
          action: this.showLinkDeviceModalDialog,
        };
      case 'email':
        return {
          label: 'Add email',
          action: this.showLinkDeviceModalDialog,
        };
      default:
        return undefined;
    }
  };

  renderPrimaryText = () => {
    const { deviceType } = this.props;

    switch (deviceType) {
      // using 'apns' to represent both iOS and Google
      // since this is just a generic empty state
      // and we should try and match the GQL types
      case 'apns':
        return 'Remind mobile app';
      case 'sms':
        return 'Phone number';
      case 'email':
        return 'Email';
      default:
        return '';
    }
  };

  renderSecondaryText = () => {
    const { deviceType } = this.props;

    switch (deviceType) {
      // using 'apns' to represent both iOS and Google
      // since this is just a generic empty state
      // and we should try and match the GQL types
      case 'apns':
        return 'Available for iPhone and Android';
      case 'sms':
        return 'Text messages and voice calls';
      case 'email':
        return 'Email notifications';
      default:
        return '';
    }
  };

  render() {
    const { deviceType, refetchDevices } = this.props;

    const mapDeviceTypeToConfirmableDeviceType: DeviceTypeToConfirmableDeviceType = {
      // `LinkDeviceModal` takes a different `deviceType` than
      // the one that gets returned from GQL; this manually defined
      // type is called ConfirmableDeviceType and is found in
      // entities/Device.js
      sms: 'phoneNumber',
      email: 'email',
    };

    return (
      <React.Fragment>
        {deviceType === 'apns' && (
          <Modal data-test="text-app-link-modal" isOpen={this.state.textAppLinkDialogIsOpen}>
            <TextAppLinkDialog onRequestHide={this.hideTextAppLinkDialog} />
          </Modal>
        )}
        {(deviceType === 'sms' || deviceType === 'email') && (
          <Modal data-test="link-device-modal" isOpen={this.state.linkDeviceModalIsOpen}>
            <LinkDeviceModal
              onRequestHide={this.hideLinkDeviceModalDialog}
              deviceType={mapDeviceTypeToConfirmableDeviceType[deviceType]}
              onDone={refetchDevices}
            />
          </Modal>
        )}
        <DeviceSettingsItemTemplate
          deviceType={deviceType}
          deviceExists={false}
          actionForNonexistentDevice={this.getAction()}
          primaryTextLabel={this.renderPrimaryText()}
          secondaryTextLabel={this.renderSecondaryText()}
        />
      </React.Fragment>
    );
  }
}
